import React from 'react';

const AdminSidebar = ({ activeSection, setActiveSection, onLogout }) => {
  const menuItems = [
    { id: 'dashboard', icon: 'fas fa-home', label: 'Dashboard' },
    { id: 'logos', icon: 'fas fa-image', label: 'Logo Management' },
    { id: 'content', icon: 'fas fa-edit', label: 'Content Management' },
    { id: 'buttons', icon: 'fas fa-link', label: 'Button Links' },
    { id: 'documents', icon: 'fas fa-file-pdf', label: 'PDF Documents' },
    { id: 'social', icon: 'fas fa-share-alt', label: 'Social Media' },
    { id: 'uploads', icon: 'fas fa-upload', label: 'File Uploads' },
    { id: 'footer', icon: 'fas fa-bars', label: 'Footer Links' },
  ];

  return (
    <div className="admin-sidebar" style={{
      width: '280px',
      background: '#2652a0',
      color: '#fff',
      padding: '20px 0',
      position: 'fixed',
      height: '100vh',
      overflowY: 'auto',
      zIndex: 1000,
      boxShadow: '4px 0 20px rgba(0, 0, 0, 0.1)'
    }}>
      <div className="sidebar-header" style={{
        padding: '0 20px 30px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <div className="admin-logo" style={{
          display: 'flex',
          alignItems: 'center',
          color: '#ffdd00',
          fontSize: '1.8rem',
          fontWeight: '700'
        }}>
          <i className="fas fa-cog" style={{ marginRight: '10px' }}></i>
          <span>Admin Panel</span>
        </div>
      </div>
      
      <nav className="sidebar-nav" style={{ padding: '20px 0' }}>
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
            onClick={() => setActiveSection(item.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '15px 20px',
              color: activeSection === item.id ? '#ffdd00' : 'rgba(255, 255, 255, 0.8)',
              background: activeSection === item.id ? 'rgba(255, 221, 0, 0.1)' : 'none',
              borderRight: activeSection === item.id ? '3px solid #ffdd00' : 'none',
              border: 'none',
              width: '100%',
              textAlign: 'left',
              fontSize: '15px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          >
            <i className={item.icon} style={{ marginRight: '10px', width: '20px', fontSize: '16px' }}></i>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="sidebar-footer" style={{ marginTop: 'auto', padding: '20px 0 0' }}>
        <button className="logout-btn" onClick={onLogout} style={{
          display: 'flex',
          alignItems: 'center',
          padding: '15px 20px',
          background: 'rgba(255, 255, 255, 0.1)',
          color: '#fff',
          border: 'none',
          width: '100%',
          textAlign: 'left',
          cursor: 'pointer',
          fontSize: '15px',
          transition: 'all 0.3s ease'
        }}>
          <i className="fas fa-sign-out-alt" style={{ marginRight: '10px' }}></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;